import script from "./EnvioItemComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./EnvioItemComponent.vue?vue&type=script&setup=true&lang=ts"

import "./EnvioItemComponent.vue?vue&type=style&index=0&id=4f2974eb&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f2974eb"]])

export default __exports__